<div class="accordion-container">
    <div class="device-title-row" [style.gap]="'4px'" [class.fullWidthTitle]="isPortsTable">
        <div class="device-title-row" (click)="isOpen = !isOpen" [class.fullWidthTitle]="isPortsTable">
            <div class="header-container">
                <div>{{ header | translate }}</div>
                <ng-container *ngIf="showEditIcon">
                    <mat-icon
                        svgIcon="more-options"
                        class="more-options"
                        (click)="openOptions(); $event.stopPropagation()">
                    </mat-icon>
                    <ng-container *ngIf="optionsVisible">
                        <div class="more-options-container" #otherOptions>
                            <div class="option-row" (click)="onEditCeuUnit.emit(); $event.stopPropagation()">
                                {{ 'dlg.edit' | translate }}
                            </div>
                            <div class="option-row" (click)="onDeleteCeuUnit.emit(); $event.stopPropagation()">
                                {{ 'dlg.delete' | translate }}
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <mat-icon class="arrow-icon" svgIcon="dropdown-arrow" [class.openContent]="isOpen" />
        </div>
        <ng-container *ngIf="hasBulkEdit">
            <div class="bulk-edit-row" (click)="onBulkEditChange.emit(!isEditing)">
                <mat-icon [svgIcon]="isEditing ? 'close' : 'edit-pen'" />
                <div>
                    {{ isEditing ? ('device-list.bulk.cancel' | translate) : ('device-list.bulk.start' | translate) }}
                </div>
            </div>
        </ng-container>
    </div>
    <ng-content *ngIf="isOpen"></ng-content>
</div>
